export default __webpack_public_path__ + "static/media/loader.c322585d.gif";